<div class="selection-backdrop">

  <div
    class="selection-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="saveModeleTitle"
    (click)="$event.stopPropagation()">

    <div class="selection-header">

      <h3
        id="saveModeleTitle"
        class="selection-title">
        Enregistrer comme modèle
      </h3>

      <button
        type="button"
        class="selection-close"
        aria-label="Fermer"
        title="Fermer"
        (click)="onCancel()">
        ×
      </button>

    </div>

    <div class="selection-body">

      <label
        class="modele-label"
        for="nomModeleOrdonnance">
        Nom du modèle
      </label>

      <div class="modele-search">

        <input
          id="nomModeleOrdonnance"
          type="text"
          class="modele-input"
          maxlength="255"
          autocomplete="off"
          autofocus
          placeholder="Saisir le nom du modèle"
          [value]="nom"
          (input)="onNomChange($event)"
          (keyup.enter)="rechercher()">

        <button
          type="button"
          class="modele-search-button"
          title="Rechercher"
          [disabled]="!nomValide || isLoading"
          (click)="rechercher()">
          <mat-icon>search</mat-icon>
        </button>

      </div>
      <div class="modele-error" *ngIf="nom && !nomValide">
        <mat-icon>warning</mat-icon>
        <span>Le nom contient des caractères non autorisés.</span>
      </div>
      <div class="modele-error" *ngIf="error">
        <mat-icon>warning</mat-icon>
        <span>{{ error }}</span>
      </div>
      <div class="modele-hint" *ngIf="!rechercheEffectuee && !isLoading">
        Saisissez un nom puis lancez la recherche.
      </div>

      <div class="modele-loading" *ngIf="isLoading">
        Recherche en cours...
      </div>

      <ng-container *ngIf="rechercheEffectuee && !isLoading">

        <!-- NOUVEAU MODELE -->
        <div
          class="modele-item modele-item--new"
          [class.modele-item--selected]="isSelected(nouveauChoix)"
          *ngIf="nouveauChoix"
          (click)="selectChoix(nouveauChoix)">

          <div class="modele-item__icon modele-item__icon--new">
            ✓
          </div>

          <div class="modele-item__content">

            <div class="modele-item__type">
              Nouveau modèle
            </div>

            <div class="modele-item__name">
              {{ nouveauChoix.nom }}
            </div>

            <div class="modele-item__description">
              Nom disponible
            </div>

          </div>

        </div>

        <!-- MODELES EXISTANTS -->
        <div
          class="modele-results-header"
          *ngIf="resultats.length > 0">
          Modèles existants
          <span class="modele-results-count">
            {{ total }}
          </span>
        </div>

        <div
          class="modele-results"
          *ngIf="resultats.length > 0">

          <button
            type="button"
            class="modele-item modele-item--existing"
            [class.modele-item--selected]="isSelected(choix)"
            *ngFor="let choix of resultats; trackBy: trackByModele"
            (click)="selectChoix(choix)">

            <div class="modele-item__icon modele-item__icon--existing">
              <mat-icon>description</mat-icon>
            </div>

            <div class="modele-item__content">

              <div class="modele-item__type">
                Modèle existant
              </div>

              <div class="modele-item__name">
                {{ choix.nom }}
              </div>

            </div>

          </button>

          <button
            type="button"
            class="modele-load-more"
            *ngIf="hasMore"
            [disabled]="isLoadingMore"
            (click)="loadMore()">

            <mat-icon *ngIf="!isLoadingMore">expand_more</mat-icon>

            <span>
              {{ isLoadingMore ? 'Chargement...' : 'Afficher plus' }}
            </span>

          </button>

        </div>

        <div
          class="modele-no-existing"
          *ngIf="resultats.length === 0 && nouveauChoix">
          Aucun modèle existant correspondant.
        </div>

      </ng-container>

    </div>

    <div class="selection-footer">

      <button
        type="button"
        class="selection-button selection-button-secondary"
        (click)="onCancel()">
        Annuler
      </button>

      <button
        type="button"
        class="selection-button selection-button-primary"
        [disabled]="actionDisabled"
        (click)="onValidate()">
        {{ actionLabel }}
      </button>

    </div>

  </div>

</div>
